import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export const DevopsTestLabIcon = createSvgIcon(
    <svg id="a98517fd-0655-40a4-8dda-ae47a1480280" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
        <defs>
            <linearGradient id="b80226ba-6d0d-4956-8f19-ab3101ca010c" x1="9" y1="16.39" x2="9" y2="-1.94" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#0078d4" />
                <stop offset="0.16" stopColor="#1380da" />
                <stop offset="0.53" stopColor="#3c91e5" />
                <stop offset="0.82" stopColor="#559cec" />
                <stop offset="1" stopColor="#5ea0ef" />
            </linearGradient>
            <linearGradient id="a4c1ad8b-2628-48af-97c3-ee4a90db0ba3" x1="9.88" y1="7.11" x2="9.99" y2="17.27" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#32d4f5" />
                <stop offset="0.32" stopColor="#31d1f3" />
                <stop offset="0.53" stopColor="#2ec9eb" />
                <stop offset="0.7" stopColor="#29bade" />
                <stop offset="0.86" stopColor="#22a5cb" />
                <stop offset="1" stopColor="#198ab3" />
                <stop offset="1" stopColor="#198ab3" />
            </linearGradient>
        </defs>
        <path d="M17.5,9.08a3.82,3.82,0,0,0-3.32-3.67A4.81,4.81,0,0,0,9.23.8,5,5,0,0,0,4.48,4a4.54,4.54,0,0,0-4,4.39,4.62,4.62,0,0,0,4.79,4.44,3,3,0,0,0,.42,0h7.75a.64.64,0,0,0,.2,0A3.86,3.86,0,0,0,17.5,9.08Z" fill="url(#b80226ba-6d0d-4956-8f19-ab3101ca010c)" />
        <path d="M14.81,17.2H5.17c-.31,0-.49-.49-.32-.75l3.32-4.84a.34.34,0,0,0,.07-.22V8.19A.2.2,0,0,0,8.05,8H7.87a.38.38,0,0,1-.38-.38V7.45a.38.38,0,0,1,.38-.38H12.1a.38.38,0,0,1,.38.38v.17A.38.38,0,0,1,12.1,8h-.18a.19.19,0,0,0-.19.19V11.4a.36.36,0,0,0,.07.22l3.32,4.83C15.29,16.7,15.11,17.2,14.81,17.2Z" fill="url(#a4c1ad8b-2628-48af-97c3-ee4a90db0ba3)" />
        <path d="M6.28,15.9,8.8,12.22A.94.94,0,0,0,9,11.7V10.22a.29.29,0,0,1,.29-.29h1.44a.29.29,0,0,1,.29.29V11.8a.61.61,0,0,0,.11.35l2.58,3.75a.23.23,0,0,1-.18.35h-7A.22.22,0,0,1,6.28,15.9Z" fill="#552f99" />
    </svg>
    ,
    'Devops Test Lab',
);

